// Ensures legacy code using process.env[...] continues to function under Vite.
declare global {
  interface Window {
    process: any;
  }
}

if (typeof window !== "undefined") {
  if (!window.process) {
    window.process = { env: {} };
  }
  const metaEnv = (import.meta as any).env || {};
  for (const k of Object.keys(metaEnv)) {
    window.process.env[k] = metaEnv[k];
  }
  if (!("NODE_ENV" in window.process.env)) {
    window.process.env.NODE_ENV =
      metaEnv.MODE || metaEnv.NODE_ENV || "development";
  }
}

export {}; // module scope
